import { Selectable } from '@shared';
import { Restaurant } from '@shared-data';

export class SelectableRestaurant extends Selectable(Restaurant) {}
